import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "casadeal_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const keyOf = (i) => `${i.product_id}::${i.variant || ""}`;
  const add = (item) =>
    setItems((prev) => {
      const ex = prev.find((p) => keyOf(p) === keyOf(item));
      if (ex) return prev.map((p) => (p === ex ? { ...p, quantity: Math.min(p.quantity + item.quantity, item.stock) } : p));
      return [...prev, item];
    });
  const update = (k, quantity) => setItems((prev) => prev.map((p) => (keyOf(p) === k ? { ...p, quantity } : p)));
  const remove = (k) => setItems((prev) => prev.filter((p) => keyOf(p) !== k));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.quantity * i.price, 0);

  return <CartCtx.Provider value={{ items, add, update, remove, clear, count, total, keyOf }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
